import React from "react";
import axios from "axios";
import CoursePriceCalculationModal, { calcTotalPricePayedType1 } from "../../components/Course/CoursePriceCalculationModal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import StorageCreateInvoice from "../../components/Storage/StorageCreateInvoice";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../shad/components/ui/alert-dialog"
import useSWR from "swr";
import { fetcher } from "../../components/UI/TableView/ShowPaginationData";

function NutritionSaleDetails() {
  // const dollarPrices = useSelector(state => state.dollarPrices.dollarPrices)
  const currentCenterId = '66bdca9b7add38fef2918d63'
  const [priceModal, setPriceModal] = useState({
    show: false,
    data: {},
    paymentDetails: {},
    payedType: 0,
    changeType: 1
  })
  const currentDollarPrice = useSelector(state => state.dollarPrices.currentPrice.price);
  const { data: Trainers, isLoading, error } = useSWR('/admins?type=3', fetcher)
  const history = useHistory()
  const [alertOpen, setAlertOpen] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [trainerId, setTrainerId] = useState()

  const onShowTrainerModal = (selectedProducts) => {
    setAlertOpen(true)
    setSelectedProducts(selectedProducts)
  }

  const onChangeTrainer = (trainerId) => {
    setTrainerId(trainerId)
  }

  const onSubmit = () => {
    setAlertOpen(false)
    const data = {
      price: selectedProducts.reduce((a, b) => a + (b.price * b.quantity), 0),
      items: selectedProducts.map((a) => {
        return {
          ...a,
          itemId: a._id,
        }
      }),
      trainerId,
      centerId: currentCenterId,
    }
    onChangeModal(data)
  }
  const onChangeModal = (pck = {}) => {
    setPriceModal(prev => ({ ...prev, show: !prev.show, data: pck }))
  }

  const onSubmitt = async () => {
    const data = {
      ...priceModal.data,
      iqd: calcTotalPricePayedType1({ data: { price: priceModal.data.price } }, currentDollarPrice),
      paymentDetails: {
        ...priceModal.paymentDetails, payedType: priceModal.payedType,
        changeType: priceModal.changeType
      },
    }

    try {
      await axios.post('/nutrition-sales', data)
      setPriceModal(prev => ({ ...prev, show: false, data: {} }))
      history.goBack()
    } catch (e) {
      console.log(e)
      alert(e)
    }
  }
  const onChangeModalData = (data) => {
    setPriceModal(data)
  }
  // console.log(trainerId)
  return (
    <div className="flex w-full h-full bg-white ">
      <CoursePriceCalculationModal onSubmit={onSubmitt} onChangeModalData={onChangeModalData} priceModal={priceModal} onChangeModal={onChangeModal} />
      <AlertDialog open={alertOpen} >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Please select trainer</AlertDialogTitle>
            <AlertDialogDescription>
              If this items sale by trainer, please select trainer to continue else dont select any trainer and click continue
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div>
            {isLoading || error ? <p>Loading...</p> : <select onChange={(e) => onChangeTrainer(e.target.value)} className='w-full h-10 border border-gray-300 rounded-md' >
              <option value={null} >Select Trainer</option>
              {Trainers.map((a) => <option key={a._id} value={a._id} >{a.name}</option>)}
            </select>}
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => { setAlertOpen(false) }} >Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onSubmit}>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <div className='flex flex-col w-full h-full' >
        <StorageCreateInvoice storageQuery={'/nutrition-storage/' + currentCenterId} currencyType='usd' stockQuery={'/nutrition-stocks'} onClickSubmit={onShowTrainerModal} />
      </div>
    </div>
  );
}

export default NutritionSaleDetails;